// Roles and permissions (D245). They come from the ELVA account app; in the mock one flag stands
// in: `?role=staff` is a user WITHOUT money permissions and who is not the practice owner/admin.
// Default is the practice owner (everything allowed). Mock only; read at call time.
//
// Money actions are HIDDEN (not shown and refused) for users without the permission:
// Write it off · The patient will pay it · Bill the patient · Undo a posting · Don't bill.
// Where a whole choice disappears, show MONEY_APPROVAL_NOTE once instead.

export const MONEY_APPROVAL_NOTE = 'An owner or admin approves write-offs.';

function role(): string | null {
  try {
    return new URLSearchParams(window.location.search).get('role')?.toLowerCase() ?? null;
  } catch {
    return null;
  }
}

/** A user without money permissions (and not the owner/admin): `?role=staff` (also viewer / readonly). */
export function isStaffRole(): boolean {
  const r = role();
  return r === 'staff' || r === 'viewer' || r === 'readonly';
}

/** May write off, move to the patient, bill the patient, undo a posting, or choose Don't bill. */
export function hasMoneyPermission(): boolean {
  return !isStaffRole();
}

/** Only the practice's owner can turn on pre-auth autopilot. */
export function isPracticeOwner(): boolean {
  return !isStaffRole();
}
